import { useCallback, useEffect, useState } from "react";
import {
  Grid,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import BackButton from "components/shared/BackButton";
import {
  StyledStack,
  StyledTitle,
  ButtonContainer,
  StyledMenuItem,
} from "./EditProduct.style";
import DrawerCM from "components/shared/Drawer";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { prodcutSchema, validateImg } from "validations";
import {
  deleteProductRequest,
  getProductInfoRequest,
  updateProductRequest,
  getAllDesignRequest,
  getFilterCategoryRequest,
  getCategoriesData,
  getDesingData,
  getCategoriesTypeData,
} from "api/requests";
import { useNavigate, useParams } from "react-router-dom";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import ReactHookFormSelect from "components/shared/ReactHookFormSelect";
import Toast from "helper/toast";
import DeleteModal from "components/shared/Modal/Delete";
import { convertNum } from "helper/convert-num";
import ProgressBarCM from "components/shared/ProgressBar";
import Upload from "components/shared/Upload";
import Divider from "@mui/material/Divider";
import Editor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

let types = [
  { id: 1, name: "مبلمان" },
  { id: 2, name: "اکسسوری" },
];

//////////////////////////
const formList = [
  { label: "نام محصول", type: "text", id: "title", required: true },
  // { label: "طرح", type: null, id: "design_id" },
  { label: "لینک مقاله", type: "text", id: "link", required: false },
  {
    label: "قیمت همکار (تومان)",
    type: "text",
    id: "colleague_price",
    required: true,
  },
  {
    label: "قیمت (تومان)",
    type: "text",
    id: "before_discount_price",
    required: true,
  },
  {
    label: "تخفیف (درصد)",
    type: "text",
    id: "discount_percent",
    required: false,
  },
  // { label: "توضیحات", type: "text", id: "description", required: false },
];

export default function EditProduct() {
  const params = useParams();
  const navigate = useNavigate();
  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp();
  const {
    register,
    handleSubmit,
    reset,
    control,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(prodcutSchema),
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [page, setPage] = useState(1);
  const [productData, setProductData] = useState({});
  const [design, setDesign] = useState({ data: [], count: 0 });
  const [categoryType, setCategoryType] = useState({});
  const [category, setCategory] = useState({ data: [], count: 0 });
  const [image, setImage] = useState({ url: null, isWeb: false });
  const [productDesign, setProductDesign] = useState([]);
  const [selectedType, setSelectedType] = useState({});
  const [selectedCategory, setSelectedCategory] = useState({});
  const [isAmazing, setIsAmazing] = useState(false);

  ////// editor ////////
  const [content, setContent] = useState("");
  const handleChange = (content) => {
    setContent(content);
  };

  //////////////// intialRequest ////////////////
  const getProductInfo = useCallback(async () => {
    let res = await request({
      url: getProductInfoRequest,
      values: params.productId,
    });

    if (res) {
      reset({
        title: res.title,
        link: res.link,
        design_id: res.design_id,
        category_id: res.category_id,
        before_discount_price: res.before_discount_price,
        colleague_price: res.colleague_price,
        discount_percent: res.discount_percent,
        description: res.description,
        amazing_offer: res.amazing_offer,
      });
      setProductData({
        id: res.id,
        title: res.title,
        image: res.image,
        description: res.description,
        amazing_offer: res.amazing_offer,
        link: res.link,
        price: res.price,
      });
      setImage({ url: res.image, isWeb: true });
      setIsAmazing(res.amazing_offer);
      setProductDesign(res.design.title);
      setContent(res.description);
    }
  }, [request, params.productId, reset]);

  useEffect(() => {
    getProductInfo();
  }, [getProductInfo]);

  const getDesign = useCallback(async () => {
    const res = await request({
      url: getAllDesignRequest,
      values: {
        skip: 0,
        limit: 1000,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      title: items.title,
      category_id: items.category_id,
    }));

    setDesign({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getDesign();
  }, [page, getDesign]);

  const getCategory = useCallback(
    async (values) => {
      const res = await request({
        url: getFilterCategoryRequest,
        // values: {
        //   type: values.type,
        // },
      });

      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
        type: items.type,
      }));

      setCategory({ data: transformedData, count: res.count });
    },
    [request]
  );

  useEffect(() => {
    getCategory();
  }, [getCategory]);

  const handelShowModal = () => setShowDeleteModal((state) => !state);

  ////////////////// delete product /////////////////
  const onDelete = async () => {
    handelShowModal();
    const res = await request({
      url: deleteProductRequest,
      values: params.productId,
    });
    if (res) {
      Toast({ type: "success", title: "حذف محصول" });
      navigate(-1);
    }
  };
  ////////////////// submit form /////////////////
  const onSubmit = async (data) => {
    if (
      (getValues("discount_percent") &&
        convertNum(getValues("discount_percent")) > 100) ||
      !isFinite(convertNum(getValues("discount_percent")))
    ) {
      return Toast({
        type: "custom",
        title: "مقدار فیلد درصد باید فقط شامل عدد و پایین ۱۰۰ باشد",
      });
    }
    // const transformedData = {
    //   id: params.productId,
    //   title: values.title,
    //   design_id: values.design_id,
    //   link: values.link,
    //   colleague_price: values.colleague_price,
    //   before_discount_price: values.before_discount_price,
    //   discount_percent: values.discount_percent,
    //   description: values.description,
    // };
    const res = await request({
      url: () =>
        updateProductRequest(
          { id: params.productId, image, ...data, content },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      Toast({ type: "success", title: "ویرایش محصول" });
      getProductInfo();
    }
  };

  ///////////////// handle image ////////////////
  const handleChangeImage = (val) => {
    validateImg(val);
    setImage({ url: val, isChanged: true });
  };

  return (
    <DrawerCM title="ویرایش محصول">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <>
          <Grid container my={2}>
            <Grid item mb={-2} xs={12}>
              <BackButton />
            </Grid>
            <StyledStack>
              <StyledTitle>ویرایش محصول</StyledTitle>
              <Grid container>
                <Grid item md={4} xs={12} p={1}>
                  <FormControl fullWidth>
                    <InputLabel id="select-type">سردسته</InputLabel>
                    <Select
                      labelId="select-type"
                      label="سردسته"
                      value={selectedType?.name}
                      // defaultValue={selectedType}
                      id="type"
                      {...register("type")}
                      error={Boolean(errors.type)}
                      helpertext={errors.type?.message}
                      onChange={(e) =>
                        setSelectedType({
                          name: e.target.value,
                        })
                      }
                    >
                      {types?.map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item.name}
                          style={{
                            direction: "rtl",
                          }}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={4} xs={12} p={1}>
                  <FormControl fullWidth>
                    <InputLabel id="select-category">زیردسته</InputLabel>
                    <Select
                      labelId="select-category"
                      label="زیردسته"
                      value={selectedCategory?.name}
                      // defaultValue={selectedCategory}
                      id="category"
                      {...register("category")}
                      error={Boolean(errors.category)}
                      helpertext={errors.category?.message}
                      onChange={(e) =>
                        setSelectedCategory({
                          name: e.target.value,
                        })
                      }
                    >
                      {category.data
                        ?.filter(
                          (item) =>
                            item.type ===
                            types?.find(
                              (item) => item.name === selectedType.name
                            )?.name
                        )
                        .map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.id}
                            style={{
                              direction: "rtl",
                            }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={4} xs={12} p={1}>
                  <FormControl fullWidth>
                    <ReactHookFormSelect
                      id="design_id"
                      name="design_id"
                      label="طرح"
                      control={control}
                      title="طرح"
                    >
                      {design.data?.length > 0 &&
                        design.data
                          ?.filter(
                            (item) =>
                              item.category_id ==
                              category.data?.find(
                                (item) => item.id == selectedCategory.name
                              )?.id
                          )
                          .map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.id}
                              style={{
                                direction: "rtl",
                              }}
                            >
                              {item.title}
                            </MenuItem>
                          ))}
                    </ReactHookFormSelect>
                  </FormControl>
                </Grid>
                <div
                  style={{
                    borderBottom: "2px solid #0080A1",
                    width: "100%",
                    paddingTop: "11px",
                    marginBottom: "16px",
                  }}
                />
                <Grid item md={6} xs={12} p={1}>
                  <TextField
                    label="طرح"
                    fullWidth
                    value={productDesign}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                {formList.map((items, index) => (
                  <Grid item md={6} xs={12} p={1} key={"add-product" + index}>
                    <TextField
                      id={items.id}
                      label={items.label}
                      variant="outlined"
                      required={items.required}
                      fullWidth
                      multiline={items.id === "description"}
                      rows={items.id === "description" ? 6.4 : 1}
                      {...register(items.id)}
                      error={Boolean(errors[items.id])}
                      helperText={errors[items.id]?.message}
                    />
                  </Grid>
                ))}

                <Grid item md={12} xs={12} p={1.5}>
                  {image.url && (
                    <Upload
                      refillable
                      type="edit-product"
                      isWeb={image.isWeb}
                      onChange={handleChangeImage}
                      file={image.url}
                      isLocal={!image.isWeb}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  )}
                </Grid>
                <Grid item md={12} xs={12} p={1.5}>
                  {content == null ? (
                    <Editor
                      enableToolbar={true}
                      // onChange={(text) => setContent(text)}
                      onChange={handleChange}
                      setDefaultStyle="font-family: IranSans; height: 40vh;"
                      setOptions={{
                        buttonList: buttonList.complex,
                        font: [
                          "IranSans",
                          "IranSansBold",
                          "Arial",
                          "Impact",
                          "Tahoma",
                        ],
                      }}
                    />
                  ) : (
                    content && (
                      <Editor
                        enableToolbar={true}
                        onChange={handleChange}
                        defaultValue={content}
                        setDefaultStyle="font-family: IranSans; height: 40vh;"
                        setOptions={{
                          buttonList: buttonList.complex,
                          font: [
                            "IranSans",
                            "IranSansBold",
                            "Arial",
                            "Impact",
                            "Tahoma",
                          ],
                        }}
                      />
                    )
                  )}
                </Grid>

                <Grid item md={12} xs={12} p={1.5}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...register("amazing_offer")}
                          checked={isAmazing}
                          onChange={(e) => {
                            setIsAmazing(e.target.checked);
                          }}
                        />
                      }
                      label="پیشنهاد ویژه"
                    />
                  </FormGroup>
                </Grid>

                <ButtonContainer>
                  <Button
                    color="error"
                    startIcon={<DeleteIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    onClick={handelShowModal}
                  >
                    حذف
                  </Button>
                  <Button
                    color="success"
                    startIcon={<CheckIcon />}
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    ذخیره
                  </Button>
                </ButtonContainer>
              </Grid>
            </StyledStack>
          </Grid>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={onDelete}
          />
        </>
      )}
    </DrawerCM>
  );
}
